module.exports = __webpack_public_path__ + "img/share_bg.da3dbaf0.jpg";